import { API } from "@/portal/api";
import { LOGO_IMG } from "@/portal/components/adminShared";

export const EFFECTDEAL_BRAND = {
  slug: null, company_name: "EffectDeal", title: "FLOTILA", theme: "dark", primary_color: "#f97316",
  logo_url: LOGO_IMG, tagline: "Evidence vozového parku", website: "https://www.effectdeal.com", is_default: true,
};

// Partner without own branding gets this clean, neutral look.
export const DEFAULT_PARTNER_BRAND = {
  theme: "light", primary_color: "#0f766e", logo_url: null, tagline: "Partnerský přehled vozů",
};

const textOn = (hex) => {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return "#ffffff";
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.62 ? "#111111" : "#ffffff";
};

export const resolveBrand = (brand) => {
  if (!brand) return EFFECTDEAL_BRAND;
  const b = { ...DEFAULT_PARTNER_BRAND, ...Object.fromEntries(Object.entries(brand).filter(([, v]) => v !== null && v !== undefined && v !== "")) };
  return { ...b, title: b.title || "FLOTILA", is_default: false };
};

export const brandStyle = (b) => ({ "--fl-accent": b.primary_color, "--fl-accent-text": textOn(b.primary_color) });

export const brandLogoSrc = (b) => {
  if (!b?.logo_url) return null;
  return b.logo_url.startsWith("/api") ? `${API.replace("/api", "")}${b.logo_url}` : b.logo_url;
};
